/**
 * The one thing the page and the service worker have to agree on by name.
 *
 * The worker no longer calls `skipWaiting` in `install`. A new worker waits until somebody asks for
 * it, and this string is how the asking happens: the page posts it to `registration.waiting`, the
 * worker recognises it and steps forward. Two copies of the literal, one in each half, is exactly
 * the kind of agreement that rots silently, so there is one copy and both halves import it.
 *
 * It lives here rather than in `app/pwa/serviceWorker.ts` because the worker bundle must not import
 * a module that touches `window` or `navigator`.
 */
export const APPLY_UPDATE_MESSAGE = "portal-apply-update";
